import { Day, Schedule } from "./types";
import { DAYS, DEFAULT_END_TIME, DEFAULT_START_TIME } from "./constants";
import {
  clampRangeToWindow,
  copyEventsToDay,
  getDayEnabledRange,
  isEventVisible,
} from "./utils";

interface ScheduleActions {
  copyFromPreviousDay: (dayIndex: number) => void;
  deleteEvent: (day: Day, eventIndex: number) => void;
}

// Acciones de calendario compartidas entre la vista de escritorio y la móvil.
// Solo se copian los eventos visibles dentro de la ventana [startTime, endTime].
export function useScheduleActions(
  value: Schedule,
  onChange: (schedule: Schedule) => void,
  weekdaysEnabled: boolean,
  weekendEnabled: boolean,
  startTime: string = DEFAULT_START_TIME,
  endTime: string = DEFAULT_END_TIME
): ScheduleActions {
  const copyFromPreviousDay = (dayIndex: number) => {
    if (dayIndex === 0) return;
    const prevDay = DAYS[dayIndex - 1];
    const sourceEvents = (value[prevDay.key] || []).filter((event) =>
      isEventVisible(event, startTime, endTime)
    );
    if (sourceEvents.length === 0) return;
    const day = DAYS[dayIndex];
    const range = clampRangeToWindow(
      getDayEnabledRange(day, weekdaysEnabled, weekendEnabled),
      startTime,
      endTime
    );
    if (!range) return;
    const currentEvents = value[day.key] || [];
    const copiedEvents = copyEventsToDay(sourceEvents, range);
    if (copiedEvents.length === 0) return;
    onChange({ ...value, [day.key]: [...currentEvents, ...copiedEvents] });
  };

  const deleteEvent = (day: Day, eventIndex: number) => {
    const newSchedule = { ...value };
    const dayRanges = [...(newSchedule[day.key] || [])];
    dayRanges.splice(eventIndex, 1);
    if (dayRanges.length === 0) {
      delete newSchedule[day.key];
    } else {
      newSchedule[day.key] = dayRanges;
    }
    onChange(newSchedule);
  };

  return { copyFromPreviousDay, deleteEvent };
}
